const x = {
  e1: "0px 1px 1px 0px rgba(44, 41, 38, 0.14),\n       0px 2px 1px -1px rgba(44, 41, 38, 0.12),\n       0px 1px 3px 0px rgba(44, 41, 38, 0.2)",
  e3: "0px 3px 4px 0px rgba(44, 41, 38, 0.14),\n       0px 3px 3px -2px rgba(44, 41, 38, 0.12),\n       0px 1px 8px 0px rgba(44, 41, 38, 0.2)",
  e4: "0px 4px 5px 0px rgba(44, 41, 38, 0.14),\n       0px 1px 10px 0px rgba(44, 41, 38, 0.12),\n       0px 2px 4px -1px rgba(44, 41, 38, 0.2)",
  e6: "0px 6px 10px 0px rgba(44, 41, 38, 0.14),\n       0px 1px 18px 0px rgba(44, 41, 38, 0.12),\n       0px 3px 5px -1px rgba(44, 41, 38, 0.2)",
  e8: "0px 8px 10px 1px rgba(44, 41, 38, 0.14),\n       0px 3px 14px 2px rgba(44, 41, 38, 0.12),\n       0px 5px 5px -3px rgba(44, 41, 38, 0.2)",
  e16: "0px 16px 24px 2px rgba(44, 41, 38, 0.14),\n        0px 6px 30px 5px rgba(44, 41, 38, 0.12),\n        0px 8px 10px -5px rgba(44, 41, 38, 0.2)",
  e24: "0px 24px 38px 3px rgba(44, 41, 38, 0.14),\n        0px 9px 46px 8px rgba(44, 41, 38, 0.12),\n        0px 11px 15px -7px rgba(44, 41, 38, 0.2)"
}, p = {
  xs: "0px 0px 0px 1px #0000000D",
  sm: "0px 1px 2px 0px #0000000D",
  base: "0px 1px 2px 0px #0000000F,0px 1px 3px 0px #0000001A",
  md: "0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A",
  lg: "0px 4px 6px -2px #0000000D, 0px 10px 15px -3px #0000001A",
  xl: "0px 10px 10px -5px #0000000A, 0px 20px 25px -5px #0000001A",
  "2xl": "0px 25px 50px -12px #00000040"
}, a = {
  none: "none",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  "dark-lg": "0px 15px 40px 0px #00000066, 0px 5px 10px 0px #00000033",
  outline: "0 0 0 3px rgba(245, 39, 100, 0.6)"
}, r = {
  ...p,
  ...a,
  ...x
}, g = r;
export {
  g as default,
  x as oldOdiTaxonomy,
  r as shadows,
  p as sizedShadows,
  a as specialShadows
};
